import React, { useState } from 'react';
import { merge } from './helpers.js';
import InformationIcon from 'mdi-react/InformationIcon';
import AlertIcon from 'mdi-react/AlertIcon';
import { min } from 'lodash';
import { Button } from './Button.js';
import { CSSTransition } from 'react-transition-group';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_Message__1bqQi{display:flex;align-items:stretch;min-height:56px;border-radius:10px;overflow:hidden;background-color:#1b1922;box-shadow:var(--content-box-shadow-80);position:relative;color:#fff}.styles-module_MessageBar__2hxWD{width:30px;flex:0 0 30px;text-align:center;padding-top:5px;position:relative;overflow:hidden}.styles-module_errorMessageBar__2ha7a{background:var(--color-error)}.styles-module_infoMessageBar__1grMz{background:var(--color-primary)}.styles-module_successMessageBar__ewDFm{background:var(--brown-gray)}.styles-module_Icon__35em0{fill:#fff;width:18px;height:18px;position:relative;z-index:1}.styles-module_MessageInnerContent__1zuke{padding:5px 30px 10px 10px;font-size:13px;flex:1 1 100%;display:flex;flex-direction:column;align-items:flex-start}.styles-module_Title__1u3Vf{font-size:14px;font-weight:700;line-height:1.4;margin-bottom:5px}@keyframes styles-module_FadeOutAnimation__QerjC{0%{opacity:1}to{opacity:0}}.styles-module_FadeOut__1u7Ko{animation-name:styles-module_FadeOutAnimation__QerjC;animation-duration:.25s;animation-fill-mode:both}.styles-module_ProgressBarContainer__39irV{position:absolute;left:0;top:0;width:30px;height:100%;transform:rotate(180deg)}.styles-module_ProgressBar__2OcL7{background-color:rgba(0,0,0,.15);height:100%;will-change:transform}.styles-module_RemoveButton__1bDS0{background:transparent;border:0;position:absolute;right:3px;top:3px;outline:none;color:#fff;cursor:pointer}.styles-module_ActionButton__9BN_C,.styles-module_ActionLink__sSJo7{margin-top:15px}.styles-module_MessageContent__18ztK{display:flex;width:100%}.styles-module_ActionLink__sSJo7{cursor:pointer;text-decoration:underline}.styles-module_ActionLink__sSJo7:hover{color:var(--color-primary-lighter)}.styles-module_MessageHolder__B4F29{position:fixed;width:310px;right:30px;top:15px;z-index:1}";
var styles = {"Message":"styles-module_Message__1bqQi","MessageBar":"styles-module_MessageBar__2hxWD","errorMessageBar":"styles-module_errorMessageBar__2ha7a","infoMessageBar":"styles-module_infoMessageBar__1grMz","successMessageBar":"styles-module_successMessageBar__ewDFm","Icon":"styles-module_Icon__35em0","MessageInnerContent":"styles-module_MessageInnerContent__1zuke","Title":"styles-module_Title__1u3Vf","FadeOut":"styles-module_FadeOut__1u7Ko","FadeOutAnimation":"styles-module_FadeOutAnimation__QerjC","ProgressBarContainer":"styles-module_ProgressBarContainer__39irV","ProgressBar":"styles-module_ProgressBar__2OcL7","RemoveButton":"styles-module_RemoveButton__1bDS0","ActionButton":"styles-module_ActionButton__9BN_C","ActionLink":"styles-module_ActionLink__sSJo7","MessageContent":"styles-module_MessageContent__18ztK","MessageHolder":"styles-module_MessageHolder__B4F29"};
styleInject(css_248z,{"insertAt":"top"});

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var ProgressBarOverlay = /** @class */ (function (_super) {
    __extends(ProgressBarOverlay, _super);
    function ProgressBarOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.intervalId = null;
        _this.state = { percent: 0 };
        return _this;
    }
    ProgressBarOverlay.prototype.componentDidMount = function () {
        var _this = this;
        var distance = 100 / (this.props.duration / 10);
        this.intervalId = setInterval(function () {
            var percent = _this.state.percent + distance;
            _this.setState({ percent: min([percent, 100]) });
        }, 10);
    };
    ProgressBarOverlay.prototype.componentDidUpdate = function () {
        if (this.state.percent >= 100 && this.intervalId) {
            this.props.onEnd && this.props.onEnd();
            clearInterval(this.intervalId);
        }
    };
    ProgressBarOverlay.prototype.componentWillUnmount = function () {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    };
    ProgressBarOverlay.prototype.render = function () {
        var percent = this.state.percent;
        return (React.createElement("div", { className: styles.ProgressBarContainer },
            React.createElement("div", { className: styles.ProgressBar, style: { transform: "translateY(-" + percent + "%)" } })));
    };
    return ProgressBarOverlay;
}(React.PureComponent));

var Bar = function (_a) {
    var type = _a.type, duration = _a.duration, onEnd = _a.onEnd;
    return (React.createElement("div", { className: merge(styles.MessageBar, styles[type + "MessageBar"]) },
        type === 'error' ? (React.createElement(AlertIcon, { className: styles.Icon })) : (React.createElement(InformationIcon, { className: styles.Icon })),
        !!duration && React.createElement(ProgressBarOverlay, { onEnd: onEnd, duration: duration })));
};

var Close = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("button", { type: "button", className: styles.RemoveButton, onClick: onClick }, "\u2715"));
};

var ActionButton = function (_a) {
    var onClick = _a.onClick, buttonLabel = _a.buttonLabel, buttonType = _a.buttonType;
    return buttonType === 'link' ? (React.createElement("div", { className: styles.ActionLink, onClick: function (event) { return onClick(event); } }, buttonLabel)) : (React.createElement(Button, { className: styles.ActionButton, color: "Secondary", onClick: function (event) { return onClick(event); } }, buttonLabel));
};

var Text = function (_a) {
    var title = _a.title, description = _a.description;
    return (React.createElement("div", { className: styles.Texts },
        React.createElement("div", { className: styles.Title }, title),
        description));
};

var MessageContainer = function (_a) {
    var type = _a.type, id = _a.id, removeOnHoverTimeOut = _a.removeOnHoverTimeOut, removeOnHover = _a.removeOnHover, remove = _a.remove, onConfirm = _a.onConfirm, timeout = _a.timeout, children = _a.children;
    var _b = useState(true), visible = _b[0], setVisible = _b[1];
    var _c = useState(timeout), duration = _c[0], setDuration = _c[1];
    var handleMouseEnter = function () {
        if (duration) {
            setDuration(null);
        }
    };
    var handleMouseLeave = function () {
        if (removeOnHover) {
            setDuration(removeOnHoverTimeOut);
        }
    };
    var handleButtonClick = function () {
        if (onConfirm) {
            onConfirm();
        }
        remove();
    };
    return (React.createElement(CSSTransition, { in: visible, timeout: 250, appear: true, classNames: {
            exit: styles.FadeOut,
        }, mountOnEnter: true, unmountOnExit: true, onExited: remove },
        React.createElement("div", { "data-cy": type + "-" + id, className: styles.Message, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, children({
            duration: duration,
            onClick: handleButtonClick,
            setVisible: setVisible,
        }))));
};

var Message = function (_a) {
    var buttonLabel = _a.buttonLabel, buttonType = _a.buttonType, controlled = _a.controlled, description = _a.description, dismissible = _a.dismissible, id = _a.id, onConfirm = _a.onConfirm, remove = _a.remove, removeOnHover = _a.removeOnHover, removeOnHoverTimeOut = _a.removeOnHoverTimeOut, timeout = _a.timeout, title = _a.title, type = _a.type;
    return (React.createElement(MessageContainer, { id: id, remove: remove, timeout: timeout, type: type, removeOnHover: dismissible && removeOnHover, removeOnHoverTimeOut: removeOnHoverTimeOut, onConfirm: onConfirm }, function (_a) {
        var duration = _a.duration, onClick = _a.onClick, setVisible = _a.setVisible;
        return (React.createElement("div", { className: styles.MessageContent },
            React.createElement(Bar, { type: type, duration: duration, onEnd: controlled ? null : function () { return setVisible(false); } }),
            React.createElement("div", { className: styles.MessageInnerContent },
                React.createElement(Text, { title: title, description: description }),
                onConfirm && (React.createElement(ActionButton, { buttonType: buttonType, onClick: onClick, buttonLabel: buttonLabel }))),
            dismissible && React.createElement(Close, { onClick: function () { return setVisible(false); } })));
    }));
};
var MessageHolder = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement("div", { className: merge(styles.MessageHolder, className) }, children);
};
Message.defaultProps = {
    removeOnHover: true,
    removeOnHoverTimeOut: 1000,
    dismissible: true,
    buttonType: 'button',
    controlled: false,
};

export { Message, MessageHolder };
